import {AccountBasicFragment} from '../schema-types/AccountBasicFragment';

import {useLocalStorage} from './useLocalStorage';

export type SearchAccountProps = Pick<AccountBasicFragment, 'curoId' | 'id'>;

export const useRecentClients = () => {
  const [previousSearches, _setPreviousSearches] = useLocalStorage<SearchAccountProps[]>(
    'previous_searches_sept_2022',
    []
  );
  const setRecentSearch = (account: SearchAccountProps) => {
    const newAccount: SearchAccountProps = {
      curoId: account.curoId,
      id: account.id,
    };
    _setPreviousSearches((prev) => [
      newAccount,
      ...prev.filter((p) => p.id !== account.id).slice(0, 15),
    ]);
  };
  const removeRecentSearch = (accountId: string) => {
    _setPreviousSearches((prev) => [...prev.filter((p) => p.id !== accountId)]);
  };
  const removeAllSearches = () => {
    _setPreviousSearches([]);
  };
  return {
    previousSearches,
    setRecentSearch,
    removeRecentSearch,
    removeAllSearches,
  };
};
